import React from "react";
import { ReactComponent as IconCommonError } from "../../../assets/iconCommonError.svg";
import { motion, AnimatePresence } from "framer-motion";
import "./ErrorMsgBox.scss";

const variants = {
  initial: { y: "50%", opacity: 0 },
  animate: { y: 0, opacity: 1, transition: { ease: "linear", duration: 0.1 } },
  exit: {
    y: "100%",
    opacity: 0,
    transition: { ease: "linear", duration: 0.1 },
  },
};

const ErrorMsgBox = ({ visible = false, children }) => {
  return visible ? (
    <div className="ErrorMsgBox">
      <AnimatePresence>
        <motion.div variants={variants} initial="initial" animate="animate" exit="exit">
          <IconCommonError />
          <div className="error font_regular text_brightOrange">{children}</div>
        </motion.div>
      </AnimatePresence>
    </div>
  ) : null;
};

export default ErrorMsgBox;
